import type { ProcessedCourse } from "@/common/course/types";
import { getCoursePriceAndCurrency } from "@/lib/course/utils/getCoursePrice";
import type { DetailPricingData } from "./useDetailPricingData";

/** Builds PDP pricing shape from the active course run seats. */
export const buildDetailPricingFromCourse = (
  course: ProcessedCourse,
): DetailPricingData | null => {
  const activeCourseRun = course.activeCourseRun;
  if (!activeCourseRun) {
    return null;
  }

  const { price: originalPrice, currency } =
    getCoursePriceAndCurrency(activeCourseRun);
  if (!originalPrice) {
    return null;
  }

  return {
    originalPrice,
    discountedPrice: originalPrice,
    currency,
  };
};
